import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, isRef as _isRef, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("h5", { class: "mt-20" }, "Media Upload", -1)
const _hoisted_2 = { style: {"padding":"6px"} }
const _hoisted_3 = {
  key: 0,
  style: {"padding":"6px"}
}
const _hoisted_4 = {
  key: 1,
  class: "create__field__body",
  style: {"display":"grid","grid-template-columns":"repeat(4, 1fr)","padding":"20px 0"}
}
const _hoisted_5 = ["onClick"]
const _hoisted_6 = ["onClick"]
const _hoisted_7 = { style: {"outline":"none","border":"none","background":"#fff","width":"20px","height":"20px","border-radius":"100%","position":"absolute","top":"0","right":"0","z-index":"2","cursor":"pointer"} }
const _hoisted_8 = {
  key: 1,
  style: {"align-items":"center"}
}
const _hoisted_9 = { style: {"font-size":"14px","text-align":"center"} }
const _hoisted_10 = { style: {"size":"12px"} }
const _hoisted_11 = ["src", "alt"]
const _hoisted_12 = /*#__PURE__*/_createElementVNode("span", null, "Title:", -1)
const _hoisted_13 = /*#__PURE__*/_createElementVNode("span", null, "Description:", -1)
const _hoisted_14 = { class: "dialog-footer" }

import { computed, reactive, ref, watch } from 'vue';
  import { useCommonStore } from '@/stores/CommonStore';
  import { useMediaStore } from '@/stores/MediaStrore';
  import notification from '@/helpers/Notification';

  
export default /*#__PURE__*/_defineComponent({
  __name: 'MediaLibraryDrawer',
  setup(__props) {

  const tabs = {
    media_upload: 'media_upload',
    media_resources: 'media_resources',
  };

  let searchQuery = ref(null);

  let mediaData = reactive({
    title: null,
    description: null,
    file: null,
    activeTab: tabs.media_upload,
  });

  const inputFile = ref<HTMLDivElement | null>(null);
  let offset = 20;

  const commonStore = useCommonStore();
  const mediaStore = useMediaStore();

  const openDrawer = ref(false);
  const dialogEditVisible = ref(false);
  const dialogSelectedImage = ref(null);

  const isOpenMediaLibraryDrawer = computed(
    () => commonStore.isOpenedMediaLibraryDrawer
  );

  const mediaResources = computed(() => mediaStore.getResources);

  const isRequestInProgress = computed(() => commonStore.isRequestInProgress);

  watch(isOpenMediaLibraryDrawer, (value) => {
    openDrawer.value = value;
  });

  watch(openDrawer, (value) => {
    if (!value) {
      clearMediaLibraryDrawer();
      commonStore.setMediaLibraryDrawer(value);
    }
  });

  const confirmDeleteImage = (image: any) => {
    mediaStore.remove(image.id);
  };

  const editImage = (image: any) => {
    mediaStore.update(image);
  };

  const infoImage = (image: any) => {
    return Object.entries(image.info).map((a) => a.join(': '));
  };

  const noResults = () => {
    if (searchQuery.value !== null) {
      if (searchQuery.value.length > 2 && mediaResources.value?.length === 0) {
        return true;
      }
    }
  };

  const clearMediaLibraryDrawer = () => {
    offset = 20;
    searchQuery.value = null;
    inputFile.value.value = '';
    mediaData.activeTab = tabs.media_upload;
    mediaData.title = null;
    mediaData.description = null;
    mediaData.file = null;
    mediaStore.resources = [];
    mediaStore.isFullyLoaded = false;
  };

  const handleTabClick = (tab: any) => {
    mediaData.activeTab = tab.props.name;

    if (tab.props.name === tabs.media_resources) {
      clearMediaLibraryDrawer();
      mediaStore.index();
    }
  };

  const fileSelected = (event: Event) => {
    mediaData.file = event.target?.files[0];
  };

  const upload = async () => {
    try {
      await mediaStore.upload(mediaData);
      notification('Upload image', '', 'success');
      clearMediaLibraryDrawer();
      mediaStore.index();
      mediaData.activeTab = tabs.media_resources;
    } catch (e: any) {
      notification('Upload image ', e, 'error');
    }
  };

  const search = () => {
    if (searchQuery.value === '') {
      mediaStore.resources = [];
      mediaStore.index();
    }
    if (searchQuery.value && searchQuery.value.length > 2)
      mediaStore.index({ search: searchQuery.value });
  };

  async function loadMore() {
    await mediaStore.index({ search: searchQuery.value, offset });
    offset = offset + 20;
  }

return (_ctx: any,_cache: any) => {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_tab_pane = _resolveComponent("el-tab-pane")!
  const _component_IconEditPen = _resolveComponent("IconEditPen")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_IconDelete = _resolveComponent("IconDelete")!
  const _component_el_popconfirm = _resolveComponent("el-popconfirm")!
  const _component_el_image = _resolveComponent("el-image")!
  const _component_IconDocument = _resolveComponent("IconDocument")!
  const _component_el_tabs = _resolveComponent("el-tabs")!
  const _component_el_drawer = _resolveComponent("el-drawer")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_el_drawer, {
      modelValue: openDrawer.value,
      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((openDrawer).value = $event)),
      "with-header": false,
      size: "50%"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_tabs, {
          modelValue: _unref(mediaData).activeTab,
          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_unref(mediaData).activeTab) = $event)),
          onTabClick: handleTabClick
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_tab_pane, {
              name: tabs.media_upload,
              label: "Upload"
            }, {
              default: _withCtx(() => [
                _hoisted_1,
                _createVNode(_component_el_input, {
                  placeholder: "Media title",
                  modelValue: _unref(mediaData).title,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(mediaData).title) = $event)),
                  class: "mt-20"
                }, null, 8, ["modelValue"]),
                _createVNode(_component_el_input, {
                  placeholder: "Media description",
                  modelValue: _unref(mediaData).description,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_unref(mediaData).description) = $event)),
                  class: "mt-20"
                }, null, 8, ["modelValue"]),
                _createElementVNode("input", {
                  type: "file",
                  onChange: fileSelected,
                  ref_key: "inputFile",
                  ref: inputFile,
                  class: "mt-20"
                }, null, 544),
                _createVNode(_component_el_button, {
                  class: "el-button--info mt-20",
                  onClick: upload,
                  disabled: isRequestInProgress.value,
                  style: {"width":"100%"}
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(" Save ")
                  ]),
                  _: 1
                }, 8, ["disabled"])
              ]),
              _: 1
            }, 8, ["name"]),
            _createVNode(_component_el_tab_pane, {
              name: tabs.media_resources,
              label: "Resources"
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_2, [
                  _createVNode(_component_el_input, {
                    modelValue: _unref(searchQuery),
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_isRef(searchQuery) ? (searchQuery).value = $event : searchQuery = $event)),
                    onInput: search,
                    placeholder: "Search by media title"
                  }, null, 8, ["modelValue"])
                ]),
                (noResults())
                  ? (_openBlock(), _createElementBlock("div", _hoisted_3, "No results!"))
                  : _createCommentVNode("", true),
                (mediaResources.value.length)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(mediaResources.value, (image) => {
                        return (_openBlock(), _createElementBlock("div", {
                          style: {"margin":"6px","background":"rgba(204, 204, 204, 0.35)","height":"100px","position":"relative"},
                          key: JSON.stringify(image),
                          onClick: () => (_unref(mediaStore).media = image)
                        }, [
                          _createElementVNode("button", {
                            style: {"outline":"none","border":"none","background":"#fff","width":"20px","height":"20px","border-radius":"100%","position":"absolute","top":"0","right":"22px","z-index":"2","cursor":"pointer"},
                            onClick: ($event: any) => {
                dialogEditVisible.value = true;
                dialogSelectedImage.value = image;
              }
                          }, [
                            _createVNode(_component_el_icon, { style: {"width":"12px","height":"12px"} }, {
                              default: _withCtx(() => [
                                _createVNode(_component_IconEditPen, { style: {"width":"12px","height":"12px"} })
                              ]),
                              _: 1
                            })
                          ], 8, _hoisted_6),
                          _createVNode(_component_el_popconfirm, {
                            "confirm-button-text": "Yes",
                            "cancel-button-text": "No",
                            "icon-color": "#626AEF",
                            title: "Are you sure to delete this?",
                            onConfirm: ($event: any) => (confirmDeleteImage(image))
                          }, {
                            reference: _withCtx(() => [
                              _createElementVNode("button", _hoisted_7, [
                                _createVNode(_component_el_icon, { style: {"width":"12px","height":"12px"} }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_IconDelete, { style: {"width":"12px","height":"12px"} })
                                  ]),
                                  _: 1
                                })
                              ])
                            ]),
                            _: 2
                          }, 1032, ["onConfirm"]),
                          (image?.mime_type.includes('image'))
                            ? (_openBlock(), _createBlock(_component_el_image, {
                                key: 0,
                                src: image?.url,
                                fit: "contain",
                                style: {"display":"flex","align-items":"center","justify-content":"center","height":"100px","padding":"5px"}
                              }, null, 8, ["src"]))
                            : (_openBlock(), _createElementBlock("div", _hoisted_8, [
                                _createElementVNode("div", _hoisted_9, [
                                  _createVNode(_component_IconDocument, { style: {"width":"2em","height":"2em","margin-right":"8px"} }),
                                  _createElementVNode("p", _hoisted_10, _toDisplayString(image.file_name), 1)
                                ])
                              ]))
                        ], 8, _hoisted_5))
                      }), 128))
                    ]))
                  : _createCommentVNode("", true),
                (mediaResources.value !== undefined)
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                      (mediaResources.value.length > 0 && !_unref(mediaStore).isFullyLoaded)
                        ? (_openBlock(), _createBlock(_component_el_button, {
                            key: 0,
                            style: {"width":"100%"},
                            class: "el-button--info",
                            onClick: loadMore
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(" Load more ")
                            ]),
                            _: 1
                          }))
                        : _createCommentVNode("", true)
                    ], 64))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }, 8, ["name"])
          ]),
          _: 1
        }, 8, ["modelValue"])
      ]),
      _: 1
    }, 8, ["modelValue"]),
    (dialogSelectedImage.value !== null)
      ? (_openBlock(), _createBlock(_component_el_dialog, {
          key: 0,
          modelValue: dialogEditVisible.value,
          "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((dialogEditVisible).value = $event)),
          width: "50%",
          title: "Edit image"
        }, {
          footer: _withCtx(() => [
            _createElementVNode("span", _hoisted_14, [
              _createVNode(_component_el_button, {
                onClick: _cache[7] || (_cache[7] = ($event: any) => (dialogEditVisible.value = false))
              }, {
                default: _withCtx(() => [
                  _createTextVNode("Cancel")
                ]),
                _: 1
              }),
              _createVNode(_component_el_button, {
                type: "primary",
                onClick: _cache[8] || (_cache[8] = ($event: any) => (editImage(dialogSelectedImage.value)))
              }, {
                default: _withCtx(() => [
                  _createTextVNode(" Edit ")
                ]),
                _: 1
              })
            ])
          ]),
          default: _withCtx(() => [
            _createElementVNode("img", {
              src: `${dialogSelectedImage.value.url}`,
              alt: `${dialogSelectedImage.value.file_name}`,
              width: "230",
              height: "230",
              style: {"object-fit":"contain"}
            }, null, 8, _hoisted_11),
            _createElementVNode("div", null, [
              _hoisted_12,
              _createVNode(_component_el_input, {
                modelValue: dialogSelectedImage.value.title,
                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((dialogSelectedImage.value.title) = $event)),
                placeholder: "Please input name"
              }, null, 8, ["modelValue"])
            ]),
            _createElementVNode("div", null, [
              _hoisted_13,
              _createVNode(_component_el_input, {
                modelValue: dialogSelectedImage.value.description,
                "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((dialogSelectedImage.value.description) = $event)),
                placeholder: "Please input name"
              }, null, 8, ["modelValue"])
            ]),
            _createElementVNode("p", null, "Type: " + _toDisplayString(dialogSelectedImage.value.mime_type), 1),
            (dialogSelectedImage.value.info !== null)
              ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(infoImage(dialogSelectedImage.value), (item) => {
                  return (_openBlock(), _createElementBlock("p", {
                    style: {"text-transform":"capitalize"},
                    key: item
                  }, _toDisplayString(item), 1))
                }), 128))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }, 8, ["modelValue"]))
      : _createCommentVNode("", true)
  ], 64))
}
}

})